import {
  Component, OnInit, ViewChild,
  Inject, WritableSignal, signal,
  AfterViewInit,
  computed,
  DOCUMENT
} from '@angular/core';
import { Store } from '@ngrx/store';

import { InitNavMenueAction, ChangeNavMenueAction, UpdateNavMenueAction } from '@sortapp/shell/store/actions';
import { NavigationEnd, Router } from '@angular/router';
import { map, filter, take } from 'rxjs/operators';

import { MenuItem, ToastMessageOptions } from 'primeng/api';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

import { combineLatest, defer, Observable, of } from 'rxjs';
import cloneDeep from 'lodash/fp/cloneDeep';
import { LogUsersClientErrorAction } from '@sortapp/app/store/user/actions';



import { AuthService, CommonCheckService, EnvironmentService, GuiService, Hideelement, ISchemaOption, LipoMessageService, NovitaetenLookupService, SwitchThemeService } from 'FoxxyLib';
import { GeneralResultEnum, IAuthUser, IClientError, ISortimentierenEnvironment, MessageTypeEnum, NavMenuItem, NavMenuItemTypeEnum, NovitätEnum } from 'FoxxyInterfaces';
import { GetAllNotificationsAction } from '@sortapp/app/store/notifications/store';
import { selectNavMenues } from '@sortapp/shell/store/selectors';
import { selectallNotifications } from '@sortapp/app/store/notifications/store/selectors';
import { ExtendedOrderByDTO, QueryTokenDTO } from '@sortapp/app/api/advsortiment/models';
import { SortRouteReuseStrategy } from '@sortapp/app/classess/sort-reuse-strategy';
import { animate, state, style, transition, trigger } from '@angular/animations';





@Component({
  selector: 'sortapp-shell-navigation',
  templateUrl: 'navigation.component.html',
  styleUrls: ['navigation.component.scss'],
  standalone: false,
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class ShellNavigationComponent implements OnInit, AfterViewInit {




  fontsizeitems: MenuItem[] = [];
  styleitems: MenuItem[] = [];

  contextMenuPosition = { x: '0rem', y: '0rem' };
  @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;



  userInfo$: Observable<string> = of(null);


  userName: string;
  items: MenuItem[]; // login
  selectedStyle: MenuItem;

  navitemsBase$: Observable<NavMenuItem[]> = of([])
  selectallNotifications$ = of([]);

  @ViewChild('matmenu', { static: false }) matmenu: MatMenu;
  opened = false; // initial nur Icons
  childrenExpanded: boolean;
  authUser: any;
  sessionMessage$: Observable<string> = of("");
  isAdmin: boolean;
  isMandant: boolean;
  isLieferant: boolean;
  isSoma: boolean;
  headerHided: boolean = false;
  headerToggledIcon: WritableSignal<string> = signal("expand_less")
  navitems$: Observable<NavMenuItem[]> = of([]);
  lieferantenPortalUrl: string;
  navitems: WritableSignal<NavMenuItem[]> = signal([]);
  isEinkauf: any;
  //ab 15 wird die Klammer als Filter in die Navigation aufgenommen, darunter werden die Sortimente direkt als Untermenü angezeigt
  klammerSichtabSortimenteCount: number = 15;
  currentnavItem: WritableSignal<NavMenuItem> = signal(null);


  constructor(
    private store: Store<any>,
    private router: Router,
    private authService: AuthService,
    private messageService: LipoMessageService<ToastMessageOptions>,
    private switschLayoutService: SwitchThemeService,
    private commoncheck: CommonCheckService,
    private lookupService: NovitaetenLookupService,
    private strategy: SortRouteReuseStrategy,
    private guiService: GuiService,
    private environmentService: EnvironmentService<ISortimentierenEnvironment>,
    @Inject(DOCUMENT) private document

  ) {


    this.authService.getLipoUser().pipe(take(1)).subscribe(user => {
      this.isMandant = user.ismandant;
      this.isAdmin = user.isadmin;
      this.isLieferant = user.isLieferant;
      this.isSoma = user.ismanager;
      this.isEinkauf = user.isEinkauf;
    });

    this.userInfo$ = this.authService.claims$.pipe(
      map(claims => claims.preferred_username)
    );


    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const current = this.findNavItemByUrl(this.navitems(), event.urlAfterRedirects || event.url);
        if (current) this.currentnavItem.set(current);
      });

    this.navitemsBase$ = this.store.select(selectNavMenues);
    // muss vor dem combineLatest stehen, sonst wird das leere Platzhalter-Observable (of([])) verdrahtet
    this.selectallNotifications$ = this.store.select(selectallNotifications);

    /**Navigation mit Counting belegen
* zur Zeit Artikeldaten/ Artikelsortimentiert
*/
    this.navitems$ = combineLatest([this.navitemsBase$, this.selectallNotifications$]).pipe(
      map(([n, notifications]) => {
        try {

          if (notifications == undefined) return n;
          if (this.authUser == undefined) return n;
          const navs = cloneDeep(n) as NavMenuItem[];
          for (let i = 0; i < navs.length; i++) {
            if (navs[i].label == "Sortimentieren") {
              const parentcnt = notifications.filter(a => a.messageType == MessageTypeEnum.Artikelsortimentiert).length;
              navs[i].notificationCount = parentcnt;
            }
            if (navs[i].children && navs[i].children.length > 0) {
              navs[i].children.forEach(c => {
                //
              })
            }
            // keine weiteren z.Z.
          }
          return navs as NavMenuItem[];
        } catch (e) {
          this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser.id, modul: 'Notification to Navigation', error: e } }));
          return n as NavMenuItem[];
        }
      }));

    this.navitems$.subscribe(navs => {
      this.navitems.set(navs);
    })

  }



  ngAfterViewInit(): void {
    this.authService.getLipoUser().pipe(filter(f => f != undefined && f.id != undefined), take(1)).subscribe(user => {
      const query = <QueryTokenDTO>
        {
          filter: {
            "manager": user.shortId.toString()
          }, orderBy: [<ExtendedOrderByDTO>{ by: 'name', desc: false }]
        }
      this.lookupService.loadFilterData(NovitätEnum.sortimente, query, user.shortId.toString());

      this.lookupService.selectCommondataError$.subscribe(e => {
        if (e && e.error && e.error.generalResult == GeneralResultEnum.AuthError) {
          this.messageService.Publish({ severity: "error", summary: (e.error.userMessage ? e.error.userMessage : "Die Anmeldung ist abgelaufen"), detail: "Sie werden neu angemeldet" });
          this.authService.login();
        }
      })

      this.lookupService.selectfilteredSortimenteValues$.pipe(filter(f => f != undefined
        && f[user.shortId.toString()] && f[user.shortId.toString()] instanceof Array), take(1)).subscribe(userssortimenteValues => {

          const userssortimente = userssortimenteValues[user.shortId.toString()] ?? [];
          this.navitemsBase$.pipe(filter(f => f.length > 0), take(1)).subscribe(navs => {
            navs = this.commoncheck.getClone(navs);
            const sortimente = navs.find(f => f.label.toLowerCase() == 'sortimentieren');
            let chenged = false;
            if (sortimente) {
              if (userssortimente.length > 0 && sortimente.children.length > 0) {
                sortimente.children[0].iconClass = sortimente.iconClass.replace('progressCursor', '');
              }
              if (userssortimente.length > this.klammerSichtabSortimenteCount) {
                chenged = true;
                userssortimente.forEach(s => {
                  if (s.klammer && s.klammer.id && sortimente.children.find(o => o.label == s.klammer.name) == undefined) {
                    sortimente.children.push(<NavMenuItem>{
                      expanded: false,
                      id: this.commoncheck.getUniqueId(),
                      messageTypes: [], label: s.klammer.name, routerlink: null,
                      icon: "toc", iconClass: "defaultIcon material-icons-outlined", seperator: false, tooltip: s.klammer.name,
                      type: NavMenuItemTypeEnum.filter, notificationCount: 0, active: '',
                      children: userssortimente.filter(f => f.klammer && f.klammer.id == s.klammer.id).map(m => <NavMenuItem>{
                        expanded: false,
                        id: this.commoncheck.getUniqueId(),
                        messageTypes: [], label: m.name, routerlink: "/sortimentieren/view/" + m.id + "/-1/soma",
                        icon: "edit", iconClass: "defaultIcon material-icons-outlined", seperator: true, tooltip: m.name,
                        type: NavMenuItemTypeEnum.default, notificationCount: 0, active: ''
                      })
                    });
                  }
                })
                sortimente.children = sortimente.children.sort((a, b) => a.label.localeCompare(b.label));
              } else {
                userssortimente.forEach(sortiment0 => {
                  const link = "/sortimentieren/view/" + sortiment0.id + "/-1/soma";
                  if (sortimente.children.find(s => s.routerlink == link) == undefined) {
                    chenged = true;
                    sortimente.children.push(<NavMenuItem>{ id: this.commoncheck.getUniqueId(), expanded: false, messageTypes: [], label: sortiment0.name, routerlink: link, icon: "edit", iconClass: "defaultIcon material-icons-outlined", seperator: true, tooltip: "Sortimentieren", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' });
                  }
                })
              }
              if (chenged) {
                this.store.dispatch(new InitNavMenueAction({ entries: navs }));
              }
            }



          })
        })

    })


  }

  /**Navitem (auch in den Children) zur aktuellen Route suchen
   * exakter Treffer gewinnt, sonst der laengste passende Routerlink
   */
  private findNavItemByUrl(items: NavMenuItem[], url: string): NavMenuItem {
    if (!items || !url) return undefined;
    const path = url.split('?')[0];
    let best: NavMenuItem = undefined;
    for (const item of items) {
      if (item.routerlink == path) return item;
      if (item.routerlink && item.routerlink.length > 1 && path.startsWith(item.routerlink)
        && (best == undefined || item.routerlink.length > best.routerlink.length)) {
        best = item;
      }
      const child = this.findNavItemByUrl(item.children, path);
      if (child) {
        if (child.routerlink == path) return child;
        if (best == undefined || child.routerlink.length > best.routerlink.length) best = child;
      }
    }
    return best;
  }

  getLogoPath(): string {
    if (this.switschLayoutService.selectedTheme?.name == 'dark') return "./assets/Logo_weiss.png";
    return "./assets/Logo.png";
  }

  /**Header Sortimentieren */
  // #8830 nur für Wup wird der Haupttitel geändert
  // hier könnte man mit breadcrums abreiten, dazu ist der Platz aber zu wenig
  getHeader = computed(() => {
    var current = this.currentnavItem();
    return current && current.label && current.label.includes("Bestellliste") ? current.label : "Sortimentieren";
  }
  )



  /**Alle Notifications zusammengezählt
   * Medientipps und Artikeldaten liefern Notifications
   */
  // defer: Feld-Initializer laufen vor dem Konstruktor, ohne defer wuerden hier die
  // Platzhalter-Observables (of([])) eingefroren und der Badge bliebe immer 0
  notificationCountAll$ = defer(() => combineLatest([this.navitems$, this.selectallNotifications$])).pipe(
    map(([navs, notifications]) => {
      let sum = 0;
      if (this.authUser == undefined) return sum;
      if (notifications == undefined || notifications.length == 0) return sum;
      for (let i = 0; i < navs.length; i++) {
        if (navs[i].label == "Sortimentieren") {
          const parentcnt = notifications.filter(a => a.messageType == MessageTypeEnum.Artikelsortimentiert && a.targetUserId == this.authUser.id).length;
          sum += parentcnt;
        }
        //
        if (navs[i].children && navs[i].children.length > 0) {
          navs[i].children.forEach(c => {
            //
          })
        }
        // keine weiteren z.Z.
      }
      return sum;
    }));

  /**Zählen der badges */
  getItemParentCount(item: NavMenuItem): number {
    try {
      if (item.notificationCount == undefined) return 0;
      if (item.children != undefined && item.children.length > 0) {
        let count = 0;
        item.children.forEach(c => { count += c.notificationCount; });
        return count;
      }
      return item.notificationCount;
    } catch (e) {
      this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser.id, modul: 'Navigation getItemParentCount', error: e } }));
      return 0;
    }
  }

  canNotification(): boolean {
    return true;
  }

  gotoDashboard(): void {
    this.router.navigate(["/"]);
  }

  getSideNavClass(opened: boolean) {
    return opened ? "sidenav_open" : " sidenav_closed ";
  }


  /**Setzen der Css klasse codesesitig, da mode= 'side' nicht automatisch opened setzt */
  getContentClass(opened: boolean) {
    return opened ? "sidenav-content sidenav-content_open" : " sidenav-content sidenav-content_close ";
  }

  ngOnInit() {

    this.switschLayoutService.load();
    this.GetStyleMenus();
    this.lieferantenPortalUrl = this.environmentService.environment.lieferantenPortalUrl;
    this.document.body.classList.add(this.switschLayoutService.getThemeClass());
    this.document.body.classList.add(this.switschLayoutService.getMaterialClass());
    // #9672: Dark-Mode-Klasse auf <html>, nicht auf <body> - PrimeNG löst Tokens, die in beiden Modi gleich sind
    // (z. B. Optionsschrift = Textfarbe), am :root auf; mit der Klasse am body blieben sie dort hell
    this.document.documentElement.classList.toggle('sort-dark-mode', this.switschLayoutService.selectedTheme.name == 'dark');


    const sub = this.userInfo$.subscribe(x => this.userName = x);
    sub.unsubscribe();
    this.items = [
      {
        label: this.userName,
        items: [
          { label: "Abmelden", command: (event => this.logout()) }
        ]
      }
    ]



    const sortimentmenueitems = new Array<NavMenuItem>();
    sortimentmenueitems.push(<NavMenuItem>{ label: "Startseite Sortimentieren", routerlink: "/", icon: "dashboard", iconClass: "defaultIcon material-icons-outlined", tooltip: "Startseite", active: "active", seperator: true, type: NavMenuItemTypeEnum.default, notificationCount: 0 });


    const featuresortimentieren = this.environmentService.environment.FeatureToggle.find(f => f == "Sortimentieren");
    if ((this.isAdmin || this.isSoma) && !featuresortimentieren) {
      const sortimenteSubMenus = <NavMenuItem>{ messageTypes: [MessageTypeEnum.Artikelsortimentiert], label: "Sortimentieren", routerlink: "", icon: "assignment", iconClass: "defaultIcon material-icons-outlined", tooltip: "Sortimentieren", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' };
      sortimenteSubMenus.children = new Array<NavMenuItem>();
      sortimenteSubMenus.children.push(<NavMenuItem>{
        messageTypes: [MessageTypeEnum.ArtikelsortimentiertAlert],
        label: "Arbeitssortimente", routerlink: "/sortimentieren/view/-1/-1/soma", icon: "assignment", iconClass: "defaultIcon material-icons-outlined", seperator: true, tooltip: "Sortimentieren", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: ''
      });
      sortimentmenueitems.push(sortimenteSubMenus);
    }
    if ((this.isAdmin || this.isEinkauf) && !featuresortimentieren) {

      const einkaufSubMenus = <NavMenuItem>{
        messageTypes: [], label: "Einkauf / Bestellliste",
        routerlink: "/einkauf", icon: "local_shipping", iconClass: "defaultIcon material-icons-outlined",
        tooltip: "Einkauf / Bestellliste", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: ''
      };

      sortimentmenueitems.push(einkaufSubMenus);
    }


    if ((this.isAdmin || this.isSoma) && !featuresortimentieren) {

      sortimentmenueitems.push(<NavMenuItem>{
        messageTypes: [], label: "Sortimentsmatrix",
        routerlink: this.lieferantenPortalUrl + "/sortimentieren/sortimentsmatrix", icon: "display_settings",
        iconClass: "defaultIcon material-icons-outlined", seperator: true,
        tooltip: "Sortimentmatrix", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: ''
      });
    }




    if ((this.isAdmin || this.isSoma)) {
      const novitaetenMenu = <NavMenuItem>{ messageTypes: [], label: "Novitäten", routerlink: '', icon: "call_made", iconClass: "defaultIcon material-icons-outlined", tooltip: "Lieferantenportal", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' };
      novitaetenMenu.children = new Array<NavMenuItem>();
      novitaetenMenu.children.push(<NavMenuItem>{ messageTypes: [], label: "Novitäteninkauf SoMa", routerlink: this.lieferantenPortalUrl + "/novi", icon: "shopping_cart", iconClass: "defaultIcon material-icons-outlined", seperator: false, tooltip: "Noviprozess SoMa", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' });
      novitaetenMenu.children.push(<NavMenuItem>{ label: "Novitäteneinkauf WuP", routerlink: this.lieferantenPortalUrl + "/wup", icon: "local_shipping", iconClass: "defaultIcon material-icons-outlined", seperator: false, tooltip: "Novitäteneinkauf WuP", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' });
      sortimentmenueitems.push(novitaetenMenu);
    }



    if (this.isLieferant == true || this.isAdmin == true || this.isSoma == true) // mindestens lieferant / kein Mandant hier reinlassen
    {
      //TODO: vorerst raus, Timeline des Sortimentierens war mal angedacht
      // sortimentmenueitems.push(<NavMenuItem>{ messageTypes: [MessageTypeEnum.Aenderungshistorie], label: "Kalender", routerlink: "/calendar", icon: "today", iconClass: "defaultIcon material-icons-outlined", seperator: false, tooltip: "Kalender", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' });
    }



    //  navitems.push(<NavMenuItem>{ label: "Dokumente", routerlink: "/download", icon: "content_copy", iconClass: "defaultIcon material-icons-outlined", tooltip: "Download Bereich", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '' });


    if ((this.isAdmin || this.isSoma)) {
      const settingmenu = <NavMenuItem>{ label: "Einstellungen", routerlink: "", icon: "settings", iconClass: "defaultIcon material-icons-outlined", tooltip: "Einstellungen", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '', children: new Array<NavMenuItem>() };
      settingmenu.children = [];
      const sortimentmatrixsettings = <NavMenuItem>{ label: "Sortimentsmatrix", routerlink: this.lieferantenPortalUrl + "/sortimentmatrixsettings", icon: "store", iconClass: "defaultIcon material-icons-outlined", tooltip: "Einstellungen Sortimentmatrix", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '', children: null };
      settingmenu.children.push(sortimentmatrixsettings);
      const novitaetensettings = <NavMenuItem>{ label: "Novitäteneinkauf", routerlink: this.lieferantenPortalUrl + "/novi/settings", icon: "shopping_cart", iconClass: "defaultIcon material-icons-outlined", tooltip: "Einstellungen Novitäteneinkauf", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '', children: null };
      settingmenu.children.push(novitaetensettings);



      // var sortimentmatrixsettings = <NavMenuItem>{ label: "Sortimentsmatrix", routerlink: "sortimentmatrixsettings", icon: "store", iconClass: "defaultIcon material-icons-outlined", tooltip: "Einstellungen Sortimentmatrix", type: NavMenuItemTypeEnum.default, notificationCount: 0, active: '', children: null };

      sortimentmenueitems.push(settingmenu);
    }
    sortimentmenueitems.forEach(f => {
      f.id = this.commoncheck.getUniqueId();
    })
    this.store.dispatch(new InitNavMenueAction({ entries: sortimentmenueitems }));

    this.authService.claims$.pipe(filter(t => t.client_id), map(f => {
      return <IAuthUser>{ name: f.name, id: f.sub, client_id: f.client_id, member_of: f.member_of, }
    })).subscribe(user => {
      this.authUser = user
      //initialer NotificationCount
      this.store.dispatch(new GetAllNotificationsAction({ targetUserId: user.id }));

    });

    this.sessionMessage$ = this.authService.OAuthService.events.pipe(map(element => {
      if (element.type === 'token_expires') {
        return "Die Anmeldung am Sortimentieren-Portal läuft bald ab.";
      } else if (element.type === 'discovery_document_loaded'
        || element.type === 'silently_refreshed'
        || element.type === 'token_received'
      ) {
        return "Die Anmeldung wurde aktualisiert";
      }
      return "";
    }));






  }

  /**theme ändern */
  changetheme(e: any): void {
    try {
      const theme = this.switschLayoutService.possibleStyles[e.checked ? 1 : 0];
      this.switschLayoutService.loadTheme(theme);
      this.document.body.classList.replace(this.document.body.classList[0], this.switschLayoutService.getThemeClass());
      this.document.body.classList.replace(this.document.body.classList[1], this.switschLayoutService.getMaterialClass());
      this.document.documentElement.classList.toggle('sort-dark-mode', theme.name == 'dark');
    } catch (e) {
      this.messageService.Publish({ severity: 'warn', summary: 'Fehler beim Wechseln der Ansicht ', detail: 'Style konnte nicht hinzugefügt werden.' });
      this.document.body.className = "size_1rem_light lightMode";
      this.document.documentElement.classList.remove('sort-dark-mode');
    }

  }

  getSelectedstyleitem(): ISchemaOption {
    return this.switschLayoutService.selectedTheme;
  }

  getSelectedFontsize(): ISchemaOption {
    return this.switschLayoutService.selectedFontSize;
  }

  /**Styles und fontsize aus Menu auswählbar */
  private GetStyleMenus() {
    this.fontsizeitems = [];
    this.fontsizeitems.push(<MenuItem>{
      label: this.switschLayoutService.selectedFontSize.label, items: this.switschLayoutService.possibleFontSizes.map(m => {
        return <MenuItem>{
          label: m.label,

          command: () => {
            this.switschLayoutService.loadFontSize(m);
            // reload paddings
            this.switschLayoutService.loadTheme(this.switschLayoutService.selectedTheme);
            this.document.body.classList.replace(this.document.body.classList[0], this.switschLayoutService.getThemeClass());
            this.document.body.classList.replace(this.document.body.classList[1], this.switschLayoutService.getMaterialClass());
            this.GetStyleMenus();
          }
        };
      })
    });



    this.styleitems = this.switschLayoutService.possibleStyles.map(m => {
      return <MenuItem>{
        label: m.label
      };
    });

  }


  /**Pfeil drehen */
  getIconInputOut(): string {
    return this.opened ? "arrow_back_ios" : "arrow_forward_ios";
  }

  /**Rein / Raus des SideMenue
   * opened wird hier gesetzt um eine besseres Verhalten zu erzielen (ruckfrei)
  */
  toggle(): void {
    this.opened = !this.opened;
  }

  headerToggle(e) {
    this.headerHided = !this.headerHided;
    this.headerToggledIcon = this.headerHided ? signal("expand_more") : signal("expand_less");
    this.guiService.onHideEvent.next({ key: Hideelement.PAGEHEADER, value: this.headerHided });
  }


  /**Selektieren des Naventries
   * hier: auc hKlasse setzen für CSS, eventuell schliessen
   */
  select(event: any, item: NavMenuItem) {
    try {

      if (item == undefined) return;
      const newitem = { ...item };
      this.currentnavItem.set(item)
      if (item.type == NavMenuItemTypeEnum.filter && newitem.children && newitem.children.length > 0) {
        item.expanded = !item.expanded;
        event.stopPropagation();
        event.preventDefault();

        return;

      } else if (newitem.children && newitem.children.length > 0) {
        this.childrenExpanded = true;
        event.preventDefault();
        this.contextMenuPosition.x = (this.opened ? 18.75 : 3.75) + 'rem'; //navbar widths !
        this.contextMenuPosition.y = (event.clientY - 5) + 'px';
        this.contextMenu.menuData = { 'item': item };
        this.contextMenu.openMenu();

      } else if (newitem.routerlink) {
        if (newitem.routerlink.startsWith(this.lieferantenPortalUrl)) {

          try {
            this.authService.OAuthService.checkOrigin = true;
            this.authService.OAuthService.redirectUri = this.lieferantenPortalUrl;
            const w = window.open(newitem.routerlink, '_blank');
            setTimeout(() => {
              if (w) {
                w.location.href = newitem.routerlink;
                w.focus();

              }
            }, 1000);

          } catch (e) {
            this.store.dispatch(new LogUsersClientErrorAction({ error: <IClientError>{ userid: this.authUser?.id, modul: 'Fehler öffnen: ' + newitem.routerlink, error: e } }));

          }
          return;
        }
        newitem.active = 'active';
        this.store.dispatch(new ChangeNavMenueAction({ entry: newitem }));

        this.router.onSameUrlNavigation = 'reload';
        this.strategy.clear();
        if (this.router.url && this.router.url.startsWith("/sortimentieren/view/")) {
          // reload hack
          this.router.navigate(["/"], { state: { token: this.authService.getAccessToken() } }).then(erfolgreich => {
            // erfolgreich == false => ein Guard (z.B. CanDeactivateSortimentViewComponentGuard,
            // "Wollen Sie abbrechen ohne zu speichern ?" mit NEIN) hat das Verlassen abgelehnt.
            // Dann darf auch der zweite Schritt des Hacks nicht laufen, sonst wuerde die Ansicht
            // trotz NEIN verlassen bzw. ein zweites Mal nachgefragt.
            if (erfolgreich === false) return;
            this.router.navigate([item.routerlink], { state: { token: this.authService.getAccessToken() } });
          }).catch(e => {
            this.messageService.Publish({ severity: 'warn', summary: 'Fehler beim Navigieren', detail: 'Fehler beim Navigieren zum Sortimentieren.' });
          }).then(() => {
            //update expanded
            this.navitems$.pipe(take(1)).subscribe(navs => {
              const findeepvalue = this.commoncheck.findDeepValue(navs, "id", item.id);
              if (findeepvalue) {
                const parent = this.commoncheck.getParentElement(navs, findeepvalue);
                if (parent && parent.type == NavMenuItemTypeEnum.filter) {
                  parent.expanded = true; // update des expanded flags im Store für späteren Zugriff, z.B. beim nächsten öffnen der Navigation
                  const root = this.commoncheck.getRootElement(navs, findeepvalue);
                  this.store.dispatch(new UpdateNavMenueAction({ entry: root }));
                }
              }
            })
          })

        } else {
          this.router.navigate([item.routerlink], { onSameUrlNavigation: 'reload', state: { token: this.authService.getAccessToken() } });
        }
        if (this.opened) {
          this.toggle(); // schliessen wenn offen
        }
      } else if (this.opened == false) {
        this.toggle();
      }

    } catch (e) {

      this.messageService.Publish({ severity: 'warn', summary: 'Fehler beim Selektieren', detail: 'Fehler beim Menuepunkt auswählen.' });

    }
  }


  logout() {
    this.authService.logoff();
    // this.oauthService.initImplicitFlow();
  }


}

